import { MENUWORKSPACE } from "../../actions/workspace/";

const INITIALVALUES = {
  menuWorkspace: []
};

export default function(state = INITIALVALUES, action) {
  switch (action.type) {
    case MENUWORKSPACE:
      return [action.payload, ...state];
    default:
  }

  return state;
}
